var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsbd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1327_4801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.408 461.789C650.735 632.952 477.376 737.118 306.194 694.435C135.082 651.762 30.9145 478.393 73.6077 307.241C116.261 136.059 289.62 31.8821 460.752 74.5553C631.924 117.229 736.081 290.617 693.408 461.789Z",
    fill: "#F74A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.863 344.655C542.223 302.142 509.854 279.288 465.593 264.042L479.95 206.452L444.895 197.715L430.917 253.788C421.702 251.491 412.236 249.325 402.831 247.178L416.909 190.736L381.874 182L367.506 239.57C359.878 237.833 352.39 236.115 345.121 234.308L345.161 234.128L296.817 222.057L287.492 259.499C287.492 259.499 313.501 265.459 312.952 265.829C327.15 269.373 329.715 278.769 329.286 286.217L312.932 351.824C313.91 352.074 315.178 352.433 316.576 352.992C315.408 352.703 314.16 352.383 312.872 352.074L289.948 443.98C288.21 448.293 283.807 454.763 273.883 452.307C274.232 452.816 248.403 445.947 248.403 445.947L231 486.074L276.619 497.446C285.105 499.573 293.422 501.8 301.609 503.896L287.102 562.145L322.117 570.881L336.485 513.252C346.05 515.848 355.335 518.244 364.421 520.5L350.104 577.86L385.159 586.597L399.666 528.458C459.442 539.77 504.392 535.207 523.313 481.142C538.559 437.61 522.554 412.499 491.103 396.125C514.007 390.843 531.26 375.777 535.863 344.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.508 405.435C498.815 399.76 501.637 391.164 499.922 382.855L483.166 301.673C482.611 298.983 480.661 296.794 478.053 295.933C469.768 293.195 461.303 299.587 461.667 308.305L462.182 320.64C463.88 361.332 450.753 401.257 425.237 433.001L417.058 443.176C411.592 449.976 414.597 460.141 422.881 462.877C425.502 463.743 428.387 463.137 430.439 461.291L492.508 405.435ZM487.545 391.067C489.455 385.287 486.317 379.053 480.536 377.143C474.756 375.234 468.522 378.372 466.613 384.152C464.703 389.933 467.841 396.167 473.622 398.076C479.402 399.985 485.636 396.847 487.545 391.067Z",
    fill: "#F74A17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1327_4801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 639,
    height: 639,
    fill: "white",
    transform: "translate(64 65)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsbd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usbd.ba8239f461b11b0248e75b8dd6a69aeb.svg";